import { render, staticRenderFns } from "./CityDorms.vue?vue&type=template&id=792eb022&scoped=true&"
import script from "./CityDorms.vue?vue&type=script&lang=js&"
export * from "./CityDorms.vue?vue&type=script&lang=js&"
import style0 from "./CityDorms.vue?vue&type=style&index=0&id=792eb022&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "792eb022",
  null
  
)

export default component.exports